import styled from 'styled-components';

export const Container = styled.div`
    margin: 40px 0;
`